import { render, staticRenderFns } from "./ClaimsReturnsMenu.vue?vue&type=template&id=5ebbe98e"
import script from "./ClaimsReturnsMenu.vue?vue&type=script&lang=js"
export * from "./ClaimsReturnsMenu.vue?vue&type=script&lang=js"
import style0 from "./ClaimsReturnsMenu.vue?vue&type=style&index=0&id=5ebbe98e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports